import { Color, Flex, Icon, IconEnum, Text } from 'component-library';
import React from 'react';

export const FourPartTestItems = () => {
  const fourParts = [
    {
      title: 'Permitted Purpose',
      description:
        'Your project should involve the creation or improvement of a product or process (e.g. improving performance or quality, building new functionality, etc.)',
    },
    {
      title: 'Technical Uncertainty',
      description:
        'You should have initial questions about the feasible technical application of your project (e.g. questions related to technical capabilities, quality of design, methodology, etc.)',
    },
    {
      title: 'Process of Experimentation',
      description:
        'You should be running experiments as you build your project (e.g. A/B tests, MVPs, prototypes, etc.)',
    },
    {
      title: 'Technological in Nature',
      description:
        'Your project should rely on hard sciences (e.g. chemistry, biology, physics, computer science, engineering, etc.)',
    },
  ];

  const renderTestPart = (
    testInfo: { title: string; description: string },
    index: number,
  ) => {
    return (
      <Flex
        alignItems={'flex-start'}
        gap={8}
        key={index}
        padding={[0, 0, 16, 0]}
      >
        <div>
          <Icon
            name={IconEnum.check_circle_filled}
            color={Color.semantic.$success50}
          />
        </div>
        <Flex direction={'column'} gap={4}>
          <Text variant={'bold'} tag={'span'} size={15}>
            {testInfo.title}
          </Text>
          <Text tag={'span'} size={15}>
            {testInfo.description}
          </Text>
        </Flex>
      </Flex>
    );
  };

  return <>{fourParts.map(renderTestPart)}</>;
};
